import { styled } from '@mui/material/styles';

export const JERoot = styled('div', {
  label: 'JERoot',
})(({ theme }) => ({
  maxWidth: '100%',
  position: 'relative',
  // height: '100%',
  flex: '1 1',
  display: 'flex',
  flexDirection: 'column',

  '& input, & textarea': {
    fontFamily: theme.typography.fontFamily,
  },
}));

export const JELinesSelectAll = styled('div', {
  label: 'LineGridPanel',
})(() => ({
  fontSize: 12,
  width: '100%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  paddingLeft: 33,
  marginTop: 30,
  minHeight: 15,
}));

export const JELoader = styled('div', {
  label: 'JELoader',
})(() => ({
  position: 'absolute',
  inset: 0,
  zIndex: 10,
  pointerEvents: 'none',
  display: 'flex',
  height: '94%',

  '& .MuiCircularProgress-root': {
    margin: 'auto',
  },
}));
